import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonEditorComponent } from '../person-editor/person-editor.component';
import { Person } from '../../../models/person';
import { InstanceTypes } from '../../../models/instance-types';
import { Select, Store } from '@ngxs/store';
import { PersonEditorState } from '../../../state/PersonEditorState/PersonEditor.state';
import { Observable } from 'rxjs';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';
import { EmployerSelectionState } from '../../../state/EmployerSelectionState/EmployerSelection.state';

// this component is responsible for the top level
// actions and route change events related to the people editor
@Component({
  selector: 'person-editor-wrapper',
  templateUrl: './person-editor-wrapper.component.html',
  styleUrls: ['./person-editor-wrapper.component.css'],
  standalone: false
})
export class PersonEditorWrapperComponent implements OnInit {
  @ViewChild('personEditor') editor: PersonEditorComponent;

  @Select(PersonEditorState.getPerson)
  public person: Observable<Person>;

  @Select(PersonEditorState.getCurrentTabStatus)
  public currentTabStatus: Observable<{ IsValid: boolean; IsDirty: boolean }>;

  @Select(PersonEditorState.getSaveButtonText)
  public saveButtonText: Observable<string>;

  @Select(PersonEditorState.getHeaderName)
  public headerName: Observable<string>;
  @Select(PersonEditorState.getHeaderEmployeeType)
  public headerEmployeeType: Observable<string>;
  @Select(PersonEditorState.getHeaderStatus)
  public headerStatus: Observable<string>;

  public clientCode: string;
  public personId: number;
  public mode: 'add' | 'edit' = 'add';
  public addToPayrollRoute: string;
  @Select(PersonEditorState.getReadOnly)
  public readOnly: Observable<boolean>;

  get isEmployeePortal() {
    return this.env.instanceType == InstanceTypes.EmployeePortal;
  }

  get isClientPortal() {
    return this.env.instanceType == InstanceTypes.ClientPortal;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject('env') private env: any,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      this.clientCode = code;
      if (this.isEmployeePortal) {
        this.store.selectOnce(EmployerSelectionState.personId).subscribe(personId => {
          this.personId = personId;
          this.mode = 'edit';
        });
      } else {
        const personId = this.route.snapshot.paramMap.get('id');
        if (personId) {
          this.personId = parseInt(personId, 10);
          this.mode = 'edit';
        }
      }

      if (this.route.snapshot.queryParamMap.has('addToPayroll')) {
        this.addToPayrollRoute = this.route.snapshot.queryParamMap.get('addToPayroll');
      }
    });
  }

  // no client/person found for given ids
  public clientOrPersonNotFound() {
    // return to csr home
    this.router.navigate(['/']);
  }

  public returnToPayroll(params) {
    if (!params) {
      return;
    }

    if (params.selectedEmployee) {
      this.router.navigate([params.route], {
        queryParams: { selectedEmployee: params.selectedEmployee }
      });
    } else {
      this.router.navigate([params.route]);
    }
  }

  public onEditorLeave() {
    if (!this.isEmployeePortal) {
      // return to people list if user clicks 'Save/Continue' on last editor tab
      this.router.navigate([`/client/${this.clientCode}/people`]);
    } else this.router.navigate([`/employee/${this.clientCode}`]);
  }
}
